<app-details-loader [Height]="'70vh'" [LoaderMarginTop]="'19%'"
                    ></app-details-loader>
